<div class="email-container" loading-spin [isLoading]="reloading" [loadingSize]="'big'">
    <div class="row-btn">
        <button tam-button [tamType]="'primary'" [tamSize]="'normal'" class='email-digest-btn'
            (click)="showContextMenu($event)">
            New Email Digest
        </button>
        <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>
    </div>
    <div class="no-data" [style.display]="noDataStyle">
        <span>No Data Found</span>
    </div>
    <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-balham" [columnDefs]="columnDefs"
        [rowData]="rowData" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)"
        (selectionChanged)="onRowSelected($event)" (displayedColumnsChanged)="onDisplayedColumnsChanged($event)">
    </ag-grid-angular>
    <tam-context-menu-kendo [config]="gridContextMenuConfig"></tam-context-menu-kendo>
</div>